import * as constants from './constants';

export const start = () => ({type: constants.START});
export const success = () => ({type: constants.SUCCESS});
export const fail = () => ({type: constants.FAIL});
